export default {
  tool: {
    label: 'Creative Toolbox',
    playable: {
      name: 'Playable Templates',
      describe: 'Create playable creatives with templates',
    },
    normal: {
      name: 'Content Editor',
      describe: 'Create playable ads as easily as making a PowerPoint',
    },
    iv: {
      name: 'Video to Playable',
      describe: 'Create playable creatives from video clips',
    },
    videoTemplate: {
      name: 'Layout Templates',
      describe: 'Generate multi-ratio and multilingual videos in bulk',
    },
    videoEditor: {
      name: 'Video Editor',
      describe: 'Online video ad editing',
    },
    aiBanner: {
      name: 'URL to Image',
      describe: 'Generate image creatives from product links',
    },
    actions: {
      demoProject: 'Demo Project',
    },
    PPT: {
      name: 'Image to Video',
      describe: 'Quickly create video ads using image assets',
    },
    avatarToVideo: {
      name: 'Avatar to Video',
      describe: 'Quickly generate video ads with avatars',
    },
    recommendTool: {
      name: 'Recommended Tools',
    },
    videoTool: {
      name: 'Video Tools',
    },
    imageTextTool: {
      name: 'Image Tools',
    },
    playableTool: {
      name: 'Playable Tools',
    },
    ai: {
      name: 'AI Video',
      describe: 'Used for subtitle removal, icon replacement, AI dubbing, etc.',
    },
    banner: {
      name: 'URL to Image（Beta）',
      describe: 'Generate Ad Creative Based on Promotion Link',
    },
    commonTemplate: {
      describe:
        'Can be batch adapted to multiple ratios and multiple language versions.',
    },
  },
  playable: {
    label: {
      name: 'Playable Templates',
    },
    gameplay: {
      support: 'Support Quick Layout',
      nosupport: 'Not Support Quick Layout',
    },
    wxgame: {
      support: 'Support WeChat MiniGame',
    },
    describe:
      'There are rich templates, you can select according to the scene and demand of creative use.',
    public: 'Public',
    collection: 'My Collection',
    template: 'My Templates',
  },
  template: 'Templates',
  video: {
    describe:
      'Quickly complete batch production based on templates, supporting asset combination, size adaptation, and language adaptation.',
    filter: {
      search: 'Search',
      creative: 'Creative Template',
      multiScale: 'Layout Template',
      replaceVideo: 'Fill Video Number',
      replaceImage: 'Fill Image Number',
      replaceText: 'Fill Text Number',
      videoNum: 'Videos',
      imageNum: 'Images',
      textNum: 'Texts',
      number: 'Items',
      mainVideo: 'Main Video',
      mainDirection: 'Main Video Orientation',
    },
    table: {
      unMute: 'Unmute',
      mute: 'Mute',
      videoClips: 'Video Editor',
      quickReplace: 'Quick Replacement',
      useTemplate: 'Use',
      rules: 'Replacement is not supported.',
      recommend: 'More Templates',
      noRecommend: 'No Recommended',
      originality: 'Creative',
      multScale: 'Multi-proportion',
      end: 'At the End',
      proportionNoEmpty: 'Proportion cannot be empty',
    },
    aiBannerDialog: {
      create: 'Create Project - URL to Image',
    },
    replaceDialog: {
      create: 'Create Project - Layout Templates',
      exportScale: 'Export Ratio',
      addLanguage: 'Add New Language',
      languagePlace: 'Please select the adaptation language',
    },
  },
  iv: {
    noProject: 'No projects yet',
    createProject: 'Create Project',
  },
}
